module.exports = __webpack_public_path__ + "static/media/wireguard-white.f67d4453.svg";